export function bSearchDirective() {
  'ngInject';

  let directive= {
    restrict: 'A',
    require: 'stTable',
    scope: {
      search: "="
    },
    link: function(scope,el,att,table){
      scope.$watch('search', function(val){
        table.search(val);
      });
    }
  };

  return directive;

}